import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../../../../services/index";

// กลุ่มปลายทางสำหรับ "ส่งสลิปเข้าแชท" (ใช้บัญชี Telegram ส่วนตัวของเอเจนต์)
// คนละตัวกับ Telegram Bot ที่รับข้อความมาสร้างเคส
export const useFetchChatTargets = () => {
  const companyId = sessionStorage.getItem("activeCompanyId");
  return useQuery(["telegramChatTargetsAdmin", companyId], async () => {
    const { result } = await GET(`/api/v1/telegram/chat-targets/admin`);
    return result || [];
  });
};

export const useCreateChatTarget = () => {
  return useMutation({
    mutationFn: async (payload) =>
      await POST(`/api/v1/telegram/chat-targets`, payload),
  });
};

export const useUpdateChatTarget = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) =>
      await PUT(`/api/v1/telegram/chat-targets/${id}`, payload),
  });
};

export const useDeleteChatTarget = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/telegram/chat-targets/${id}`),
  });
};

// รายชื่อ Topic ของกลุ่ม (เฉพาะกลุ่มที่เปิดโหมดฟอรัม)
// ต้องมี session Telegram ที่ผูกไว้ — Telegram ไม่ให้คนนอกกลุ่มอ่านรายชื่อ topic
export const useFetchForumTopics = () => {
  return useMutation({
    mutationFn: async (chatId) =>
      await GET(`/api/v1/telegram/chat-targets/topics?chatId=${encodeURIComponent(chatId)}`),
  });
};
